export interface PortalAccountContact {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state_id: string;
  state: string;
  postal_code: string;
  address_id?: string | null;
}

/** Hub countries.id for the United States (matches geocode.USCountryID). */
export const PORTAL_US_COUNTRY_ID = 'f69b967c577344e38d11935ef3223e4f';
